export default __webpack_public_path__ + "static/media/i105jp.5cc6612d.webp";